/**
 * @mixin
 * Sharable mixin to use with dynamically loaded components
 */
export default {
	components: {
		'cs-notfound': () => import(/*webpackChunkName: "cs-notfound" */ '@/js/components/cs-notfound')
	},

	methods: {
		/**
		* checks to see if the component name provided exists as a key within the internal array of components for the parent .vue file
		*
		* @param {String} internalName The internal name of the component, typically the filename minus the extension (cs-grid)
		* @returns {Boolean}
		*/
		componentExists(internalName) {
			try {
				return (typeof this.$options.components[internalName] !== 'undefined');
			} catch (error) {
				this.$recordError({
					type : 'error',
					error : error,
					displayToUser : true,
					errorCode : '000084'
				});
			}
		},

		/**
		* checks to see if the component name provided exists as a key within the internal array of components for the parent .vue file
		* and returns the not found component if it does not.
		*
		* @param {String} componentName The internal name of the component, typically the filename minus the extension (cs-grid)
		* @returns {String}
		*/
		dynamicComponent(componentName, data) {
			try {
				this.$cs_.timerStart('component resolution');
				let resolvedComponentName = 'cs-notfound';
				// If passed component is a date & time picker component we're replacing it with a standard date picker component if available
				if ( componentName === 'cs-datetimepicker' ) {
					resolvedComponentName = this.componentExists('cs-datepicker') ? 'cs-datepicker' : 'cs-notfound';
				} 
				else if (componentName === 'cs-attachment') {
					resolvedComponentName = 'cs-file-upload';
				} 
				else if ( componentName === 'cs-radio' ) {
					resolvedComponentName = data?.buttonMode ? 'cs-group-buttons' : 'cs-radio';
				}
				else {
					resolvedComponentName = this.componentExists(componentName) ? componentName : 'cs-notfound';
				}
				//TODO remove the below - for development ONLY - also remove data param above
				if (data?.chartConfig?.component === 'cs-custombubble') resolvedComponentName = data.chartConfig.component;
				
				this.$cs_.timerAdd('component resolution');
				return resolvedComponentName;
			} catch (error) {
				this.$recordError({
					type : 'error',
					error : error,
					displayToUser : true,
					errorCode : '000084'
				});
			}
		}
	}
}
